import React from 'react'

export function ButtonRadio<T>({
    selected,
    label,
    id,
    value,
    description,
    icon,
    onChange
}: {
    selected: boolean
    label: string
    id: string
    value: T
    description?: string
    icon?: string
    onChange: (valueSelected: T) => void
}) {
    const handleClick = () => onChange(value)
    return (
        <div className={`buttonContainer ${selected ? 'Checked' : ''}`} onClick={handleClick}>
            <div className="mainLabelDiv">
                <label className="mainLabel">
                    {icon && (
                        <div className="iconDiv">
                            <i className={icon} />
                        </div>
                    )}
                    <div className="textDiv">
                        <div className="labelDiv" onClick={handleClick}>{label}</div>
                        {description && <div className="descriptionDiv" onClick={handleClick}>{description}</div>}
                    </div>
                </label>
            </div>
            <div className="inputContainer">
                <input
                    key={id}
                    type="radio"
                    name="radioGroup"
                    value={label}
                    checked={selected}
                    onChange={handleClick}
                />
            </div>
        </div>
    )
}
